export const SELECTION_TYPE = {
    single: 'single',
    multiple: 'multiple',
};
